import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'coachSelection',
    component: () => import(/* webpackChunkName: "coach-selection" */ '../views/CoachSelection.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "public" */ '../views/404.vue'),
  },

  // Draft mode
  {
    path: '/draft/:coach_id',
    name: 'coachProfileDraft',
    component: () => import(/* webpackChunkName: "public" */ '../views/CoachProfile.vue'),
    props: {
      mode: 'coachProfileDraft',
    },
  },
  {
    path: '/coach/draft/',
    name: 'coachProfileDraftCoach',
    component: () => import(/* webpackChunkName: "public" */ '../views/CoachProfile.vue'),
    props: {
      mode: 'coachProfileDraftCoach',
    },
  },

  // Publish mode
  {
    path: '/:url_index',
    name: 'coachProfile',
    component: () => import(/* webpackChunkName: "public" */ '../views/CoachProfile.vue'),
    props: {
      mode: 'coachProfile',
    },
  },
  {
    path: '/coach/:id',
    name: 'coachProfileByID',
    component: () => import(/* webpackChunkName: "public" */ '../views/CoachProfile.vue'),
    props: {
      mode: 'coachProfileByID',
    },
  },
  {
    path: '/gcg/:url_index',
    name: 'gcgCoachProfile',
    component: () => import(/* webpackChunkName: "public" */ '../views/CoachProfile.vue'),
    props: {
      mode: 'gcgCoachProfile',
    },
  },

  { path: '*', redirect: '/404', hidden: true },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
